import _ from "underscore";
import Notifications, { TNotificationType } from "../../utils/notifications";
import { MobileActions } from "../../store/mobile/actions";
import pageHTML from "./notifications.tmpl";
import DebugPageView from "./debugPageView";

export default class NotificationsView extends DebugPageView {
    private readonly template = _.template(pageHTML);

    /* eslint-disable @typescript-eslint/unbound-method */
    events() {
        return {
            "click #notify": this.notify
        } as Backbone.EventsHash;
    }
    /* eslint-enable @typescript-eslint/unbound-method */

    render () {
        this.el.innerHTML = this.template();

        this.app.store.dispatch(MobileActions.setPageState({
            title: "Notifications Debug",
            pageLevel: 2
        }));

        return this;
    }

    notify () {
        let notificationIdInput = <HTMLInputElement>document.getElementById("notificationId");
        let notificationTypeInput = <HTMLInputElement>document.getElementById("notificationType");
        let messageInput = <HTMLInputElement>document.getElementById("notificationMessage");
        let isCriticalCheckbox = <HTMLInputElement>document.getElementById("notificationIsCritical");

        let id = notificationIdInput.value;
        let type = <TNotificationType>(notificationTypeInput.value || "system");
        let message = messageInput.value || "Message";
        let critical = isCriticalCheckbox.checked;

        if (!id) {
            alert("Needs an ID");
            return false;
        }

        let user = this.app.userService.getCurrentUser();

        user && Notifications.add(id, { type, message, critical }, user.id);

        return undefined;
    }
}
